import { RootActionTypes } from '../../../stores/types';
import DialogName from '../constants/DialogName';
import hideDialog from './hideDialog';

export default function hideAddRuleWorksheet(): RootActionTypes {
  return hideDialog(DialogName.ADD_RULE_WORKSHEET)();
}
